import axios from "axios";

const cardValidatorBaseUrl = `${process.env.REACT_APP_BASE_URL}/services/userprofile/api/card`;

export const validateCard = async (token, cardNumber) => {
  const params = new URLSearchParams({ cardNumber });
  return await axios
    .get(`${cardValidatorBaseUrl}/validate?${params.toString()}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => response.data)
    .catch((error) => {
      if (token) return error;
    });
};

export const validateCbu = async (token, cbu) => {
  const params = new URLSearchParams({ cbu });
  return await axios
    .get(`${cardValidatorBaseUrl}/validate-cbu?${params.toString()}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => response.data)
    .catch((error) => {
      if (token) return error;
    });
};
